(function ($) {
  // Load Kueski widget
  function waitForElmShadow(selector) {
    return new Promise((resolve, reject) => {

      if(!document.querySelector(selector)){
        return reject("");
      }

      if (document.querySelector(selector)?.shadowRoot) {
        return resolve(document.querySelector(selector).shadowRoot);
      }

      const observer = new ResizeObserver(() => {
        if (document.querySelector(selector)?.shadowRoot) {
          resolve(document.querySelector(selector).shadowRoot);
          observer.disconnect();
        }
      });

      observer.observe(document.body);
    });
  }

  waitForElmShadow('kueskipay-widget').then((el) => {
    const widgetWrapper = document.querySelector('.js-installment-price-wrapper.kueski');
    const timer = setTimeout(() => {
      if (el?.querySelector('.kp-widget-root')) {
        clearInterval(timer);
        const styles = document.createElement('style');

        styles.innerHTML = `
          .kp-widget-root,
          .kp-modal-root {
              --kp-font-family: AkzidenzGroteskRegular,Helvetica,Arial,sans-serif !important;
          }
          .kp-widget-root b,
          .kp-modal-root b {
              font-family: AkzidenzGrotesk,Helvetica,Arial,sans-serif !important;
          }
          .kp-widget-root p {
            width: 100%;
            display: flex;
            gap: 4px;
            flex-wrap: wrap;
            align-items: center;
            justify-content: center;
          }
          .kp-widget-root {
            margin: 10px 5px;
            text-align: center;
          }
        `;
        el.appendChild(styles);
        // Update widget text
        const contentElement = el.querySelector('.kp-widget-root p span');

        contentElement.innerHTML = '<b>Hasta 6 pagos</b> con';
        widgetWrapper.classList.remove('hidden');
      }
    }, 500);
  }).catch((message) => {});

})(jQuery);
